import { fetchMetrics } from '../helpers';

const firePlacebo = id => {
  const encodedSiteUrl = encodeURIComponent(window.location.href);
  const encodedReferrer = encodeURIComponent(document.referrer);
  const timestamp = Date.now();
  const url = `//us.creativecdn.com/tags?type=img&id=${id}&ncm=1&su=${encodedSiteUrl}&sr=${encodedReferrer}&ts=${timestamp}`;

  fetchMetrics(url);
};

const firePixel = (id, data) => {
  const url = `//us.creativecdn.com/tags?type=img&id=${id}_${data}`;
  fetchMetrics(url);
};

const fire = (id, type, product, search, breadCrumb) => {
  if (type === 'home') {
    return firePixel(id, 'home');
  }
  if (type === 'product') {
    return firePixel(id, `offer_${product.id}`);
  }
  if (type === 'search') {
    return firePixel(id, `listing_${search.products.slice(0, 5).join()}`);
  }
  if (type === 'category') {
    return firePixel(id, `category2_${breadCrumb[0].id}`);
  }
};

export const rtbHouseInit = config => {
  document.addEventListener('page:load', ({ detail }) => {
    try {
      const { page, product, search } = detail;
      const id = config.rtbhouse;
      if (!page || !id) {
        return false;
      }

      const { type, breadCrumb } = page;

      fire(id, type, product, search, breadCrumb);
      firePlacebo(id);
    } catch (e) {
      console.warn('RTBHOUSE', e);
    }
  });
};
